import React, { useState } from 'react';
import { search_icon } from '../../../assets/images';

const SearchBar = ({ label, value = '', placeholder, onValueChange, action, classes = '' }) => {
  return (
    <div className={classes}>
      <h1 className='text-gray-700 font-semibold mb-3'>{label}</h1>
      <div className='relative flex items-center'>
        <img src={search_icon} alt='search-icon' onClick={() => value.trim() && action(value)} className='absolute right-4' />
        <input
          type='text'
          name='input-search'
          value={value}
          placeholder={placeholder}
          onChange={(event) => onValueChange(event.target.value)}
          className='bg-gray-100 border border-gray-200 text-gray-700 placeholder-gray-300 p-4 pr-7 rounded-md w-full text-gray-300 font-semibold'
        />
      </div>
    </div>
  );
};

export default SearchBar;
